export default __webpack_public_path__ + "static/media/au-sa.7e5471cd.svg";